export const translations = {
  es: {
    nav: {
      services: 'Servicios',
      process: 'Cómo trabajamos',
      projects: 'Casos reales',
      faq: 'FAQ',
      contact: 'Contacto',
      cta: 'Solicitar diagnóstico',
    },
    hero: {
      badge: 'Sistemas a medida para negocios',
      title: 'Solvere',
      subtitle: 'Sistemas que resuelven',
      description:
        'Creamos sistemas simples para resolver problemas reales: stock, procesos y tareas que hoy te hacen perder tiempo o plata.',
      cta: 'Solicitar diagnóstico',
      ctaSecondary: 'Ver casos reales',
      features: {
        cloud: 'En la nube',
        process: 'Procesos claros',
        secure: 'Seguridad real',
      },
      panelTitle: 'Ordená tu negocio. Recuperá el control.',
      panelText:
        'Analizamos cómo trabajás y desarrollamos una herramienta a medida, usable desde el primer día.',
      panelItems: [
        {
          title: 'Diagnóstico preciso',
          description: 'Detectamos cuellos de botella, tareas duplicadas y puntos de fuga de tiempo.',
        },
        {
          title: 'Desarrollo a medida',
          description: 'Armamos una solución pensada para tu operatoria, no una plantilla disfrazada.',
        },
        {
          title: 'Implementación simple',
          description: 'Lo dejamos funcionando y te acompañamos para que lo uses sin complicaciones desde el primer día.',
        },
        {
          title: 'Enfocado en resultados',
          description: 'La solución se diseña para resolver un problema concreto y acompañar el crecimiento de tu negocio.',
        },
      ],
    },
    services: {
      kicker: 'Servicios',
      title: 'Soluciones pensadas para problemas reales',
      subtitle:
        'Cada proyecto parte de una necesidad concreta: ordenar, automatizar, integrar y hacer más simple el trabajo diario.',
      items: [
        {
          title: 'Sistemas de gestión',
          description:
            'Desarrollamos plataformas para controlar stock, precios, ventas, pedidos, reportes y circuitos internos con acceso desde cualquier dispositivo.',
          features: ['Stock', 'Ventas', 'Reportes', 'Usuarios', 'Panel administrativo'],
        },
        {
          title: 'Soluciones para talleres y rubros técnicos',
          description:
            'Creamos herramientas para órdenes de trabajo, seguimiento de clientes, control de repuestos, historial de servicios y trazabilidad operativa.',
          features: ['Órdenes', 'Clientes', 'Repuestos', 'Historial', 'Seguimiento'],
        },
        {
          title: 'Aplicaciones móviles',
          description:
            'Desarrollamos apps Android para tareas específicas como relevamiento, carga en campo, escaneo QR o consulta rápida de información crítica.',
          features: ['Android', 'QR', 'Carga móvil', 'Consulta rápida', 'Sincronización'],
        },
        {
          title: 'Automatización e integraciones',
          description:
            'Conectamos sistemas, APIs, formularios, alertas y procesos para que tu operación tenga menos pasos manuales y menos margen de error.',
          features: ['APIs', 'Alertas', 'Integraciones', 'Webhooks', 'Automatización'],
        },
      ],
    },
    process: {
      kicker: 'Cómo trabajamos',
      title: 'Un proceso claro, sin vueltas innecesarias',
      subtitle:
        'Primero entendemos el problema real. Después definimos la mejor forma de resolverlo. Recién ahí desarrollamos.',
      description:
        'La idea no es llenarte de tecnicismos ni venderte funciones que quedan lindas en una demo. La idea es que el sistema te ordene el trabajo, reduzca errores y sea fácil de usar desde el primer día.',
      steps: [
        {
          title: 'Diagnóstico',
          description:
            'Revisamos cómo trabajás hoy, dónde se pierde tiempo y qué cosas están generando errores o desorden.',
        },
        {
          title: 'Diseño de solución',
          description:
            'Definimos una propuesta concreta según tu operatoria, tus prioridades y el nivel de control que necesitás.',
        },
        {
          title: 'Desarrollo e implementación',
          description:
            'Construimos el sistema, lo ajustamos contigo y lo dejamos funcionando en condiciones reales de uso.',
        },
        {
          title: 'Seguimiento',
          description:
            'Acompañamos la puesta en marcha, resolvemos ajustes y dejamos la base lista para crecer.',
        },
      ],
    },
    projects: {
      kicker: 'Casos reales',
      title: 'Soluciones que ya están funcionando',
      subtitle:
        'Ejemplos concretos de sistemas desarrollados para resolver problemas reales en distintos entornos de trabajo.',
      stackLabel: 'Incluye',
      items: [
        {
          title: 'Stock Central',
          description:
            'Control de stock y consumo en tiempo real en la nube, con registro inmediato y stock siempre actualizado.',
          tech: ['Stock en tiempo real', 'Consumo', 'Nube', 'Control operativo'],
        },
        {
          title: 'Gestión de negocio',
          description:
            'Sistema con control de stock, escaneo de precios desde el celular y generación de etiquetas QR.',
          tech: ['Stock', 'Scanner móvil', 'Precios', 'Etiquetas QR'],
        },
        {
          title: 'Biblioteca virtual UCIN',
          description:
            'Plataforma interna para centralizar documentos, manuales, capacitaciones y videos en un solo lugar.',
          tech: ['Documentos', 'Manuales', 'Capacitaciones', 'Videos'],
        },
        {
          title: 'Control de taller',
          description:
            'Sistema para ventas, caja, control de stock, órdenes de trabajo, avisos de reposición y seguimiento de clientes.',
          tech: ['Ventas', 'Caja', 'Órdenes', 'Reposición', 'Clientes'],
        },
      ],
    },
    faq: {
      kicker: 'FAQ',
      title: 'Preguntas frecuentes',
      subtitle: 'Lo importante, sin vueltas.',
      items: [
        {
          question: '¿Trabajan con soluciones estándar o a medida?',
          answer:
            'A medida. Podemos reutilizar componentes para acelerar tiempos, pero la lógica del sistema se adapta a tu negocio, no al revés.',
        },
        {
          question: '¿Necesito equipos especiales para usar el sistema?',
          answer:
            'No. La mayoría de las soluciones funcionan desde navegador y pueden usarse en PC, notebook, tablet o celular. Si el caso lo requiere, también desarrollamos apps específicas.',
        },
        {
          question: '¿Pueden integrar la solución con otras herramientas?',
          answer:
            'Sí. Podemos conectar formularios, APIs, servicios externos, alertas automáticas y otros sistemas para evitar carga duplicada y mejorar el flujo de trabajo.',
        },
        {
          question: '¿Incluyen soporte después de la entrega?',
          answer:
            'Sí. La implementación no termina el día que se publica. Acompañamos la puesta en marcha y los ajustes necesarios para que la herramienta quede firme.',
        },
        {
          question: '¿Cómo se define el costo?',
          answer:
            'Depende del alcance, la complejidad y las integraciones que necesite el proyecto. Primero relevamos, después presupuestamos con criterio. Así evitamos inventar números al voleo.',
        },
      ],
    },
    contact: {
      kicker: 'Contacto',
      title: 'Hablemos de tu proyecto',
      subtitle:
        'Contanos qué necesitás resolver y te respondemos por correo con una propuesta clara.',
      form: {
        name: 'Nombre',
        email: 'Correo electrónico',
        phone: 'Teléfono',
        business: 'Empresa o rubro',
        message: 'Mensaje',
        messagePlaceholder: 'Contanos qué necesitás resolver, qué proceso querés mejorar o qué idea tenés en mente.',
        submit: 'Enviar consulta',
        success: 'Se preparó tu mensaje.',
        successDetail: 'Solo falta confirmar el envío desde tu app de correo.',
        notice:
          'Este formulario utiliza tu aplicación de correo predeterminada para enviar la consulta. Si querés, también podés escribir directo a contacto@solvere.com.ar.',
      },
    },
    footer: {
      tagline:
        'Desarrollo de sistemas web, automatización e integraciones para empresas que necesitan herramientas útiles, no adornos digitales.',
      rights: 'Todos los derechos reservados',
      services: 'Servicios',
      company: 'Empresa',
    },
  },
  en: {
    nav: {
      services: 'Services',
      process: 'How we work',
      projects: 'Case studies',
      faq: 'FAQ',
      contact: 'Contact',
      cta: 'Request a diagnosis',
    },
    hero: {
      badge: 'Custom systems for businesses',
      title: 'Solvere',
      subtitle: 'Systems that solve',
      description:
        'We build simple systems to solve real business problems: inventory, processes, and tasks that waste time or money today.',
      cta: 'Request a diagnosis',
      ctaSecondary: 'View case studies',
      features: {
        cloud: 'Cloud based',
        process: 'Clear processes',
        secure: 'Real security',
      },
      panelTitle: 'Organize your business. Regain control.',
      panelText:
        'We analyze how you work and build a custom tool that is usable from day one.',
      panelItems: [
        {
          title: 'Accurate diagnosis',
          description: 'We identify bottlenecks, duplicated tasks, and where time leaks out.',
        },
        {
          title: 'Custom development',
          description: 'We build a solution for your operation, not a template wearing a tie.',
        },
        {
          title: 'Simple rollout',
          description: 'We support implementation so the transition works from day one.',
        },
        {
          title: 'Results focused',
          description: 'Your system grows with the business instead of freezing as an old promise.',
        },
      ],
    },
    services: {
      kicker: 'Services',
      title: 'Solutions designed for real problems',
      subtitle:
        'Every project starts from a concrete need: organize, automate, integrate, and simplify daily work.',
      items: [
        {
          title: 'Management systems',
          description:
            'We build platforms to control inventory, pricing, sales, orders, reports, and internal workflows from any device.',
          features: ['Inventory', 'Sales', 'Reports', 'Users', 'Admin panel'],
        },
        {
          title: 'Solutions for workshops and technical businesses',
          description:
            'We create tools for work orders, customer follow-up, spare parts control, service history, and operational traceability.',
          features: ['Work orders', 'Customers', 'Parts', 'History', 'Tracking'],
        },
        {
          title: 'Mobile applications',
          description:
            'We develop Android apps for specific tasks such as field data capture, QR scanning, and fast access to critical information.',
          features: ['Android', 'QR', 'Mobile input', 'Quick access', 'Sync'],
        },
        {
          title: 'Automation and integrations',
          description:
            'We connect systems, APIs, forms, alerts, and workflows so your operation has fewer manual steps and fewer mistakes.',
          features: ['APIs', 'Alerts', 'Integrations', 'Webhooks', 'Automation'],
        },
      ],
    },
    process: {
      kicker: 'How we work',
      title: 'A clear process, without unnecessary complexity',
      subtitle:
        'First we understand the real problem. Then we define the best way to solve it. Only then do we build.',
      description:
        'The goal is not to overwhelm you with technical jargon or sell features that look nice in a demo. The goal is to give you a system that organizes work, reduces mistakes, and is easy to use from day one.',
      steps: [
        {
          title: 'Diagnosis',
          description:
            'We review how you work today, where time is being lost, and which issues are creating errors or disorder.',
        },
        {
          title: 'Solution design',
          description:
            'We define a practical proposal based on your operation, your priorities, and the level of control you need.',
        },
        {
          title: 'Development and rollout',
          description:
            'We build the system, refine it with you, and launch it in real working conditions.',
        },
        {
          title: 'Follow-up',
          description:
            'We support the go-live, handle adjustments, and leave a solid base ready to grow.',
        },
      ],
    },
    projects: {
      kicker: 'Case studies',
      title: 'Solutions already working',
      subtitle:
        'Concrete examples of systems built to solve real problems in different work environments.',
      stackLabel: 'Includes',
      items: [
        {
          title: 'Central Inventory',
          description:
            'Cloud-based real-time inventory and consumption control with immediate records and always updated stock.',
          tech: ['Real-time stock', 'Consumption', 'Cloud', 'Operational control'],
        },
        {
          title: 'Business management',
          description:
            'System with inventory control, mobile price scanning, and QR label generation.',
          tech: ['Inventory', 'Mobile scanner', 'Pricing', 'QR labels'],
        },
        {
          title: 'NICU virtual library',
          description:
            'Internal platform to centralize documents, manuals, training material, and videos in one place.',
          tech: ['Documents', 'Manuals', 'Training', 'Videos'],
        },
        {
          title: 'Workshop control',
          description:
            'System for sales, cash register, inventory control, work orders, restocking alerts, and customer tracking.',
          tech: ['Sales', 'Cash register', 'Work orders', 'Restocking', 'Customers'],
        },
      ],
    },
    faq: {
      kicker: 'FAQ',
      title: 'Frequently asked questions',
      subtitle: 'The important part, without fluff.',
      items: [
        {
          question: 'Do you work with standard products or custom solutions?',
          answer:
            'Custom solutions. We may reuse components to save time, but the system logic adapts to your business instead of forcing your business to adapt to the tool.',
        },
        {
          question: 'Do I need special equipment to use the system?',
          answer:
            'No. Most solutions run in the browser and can be used on desktop, laptop, tablet, or phone. When needed, we can also build dedicated apps.',
        },
        {
          question: 'Can you integrate the solution with other tools?',
          answer:
            'Yes. We can connect forms, APIs, external services, automatic alerts, and other systems to reduce duplicated work and improve workflow.',
        },
        {
          question: 'Do you include support after delivery?',
          answer:
            'Yes. Implementation does not end the day the system goes live. We support the rollout and the adjustments needed to make it solid.',
        },
        {
          question: 'How is pricing defined?',
          answer:
            'It depends on scope, complexity, and required integrations. We assess first and quote with criteria afterward. Guessing numbers up front is a circus, and we are not selling tickets for that.',
        },
      ],
    },
    contact: {
      kicker: 'Contact',
      title: 'Let’s talk about your project',
      subtitle:
        'If you need a concrete solution, write to us. The form opens your email client with the message prepared and addressed to contacto@solvere.com.ar.',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        business: 'Business or company',
        message: 'Message',
        messagePlaceholder: 'Tell us what you need to solve, what process you want to improve, or what idea you have in mind.',
        submit: 'Send inquiry',
        success: 'Your message is ready.',
        successDetail: 'You only need to confirm the send from your mail app.',
        notice:
          'This form uses your default email application to send the inquiry. You can also write directly to contacto@solvere.com.ar.',
      },
    },
    footer: {
      tagline:
        'Web systems, automation, and integrations for businesses that need useful tools instead of digital decoration.',
      rights: 'All rights reserved',
      services: 'Services',
      company: 'Company',
    },
  },
};
